export default function forDate(date, cb) {
  var df = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var td = date && typeof date === 'string' && date.length ? new Date(date) : date;
  return td instanceof Date && !Number.isNaN(td.valueOf()) ? cb(td) : df;
}